var map = {
	"./airconditioner.jpg": 966,
	"./alarmclock.jpg": 218,
	"./bicycle.jpg": 591,
	"./boardgames.jpg": 697,
	"./chair.jpg": 178,
	"./cleaningsupplies.jpg": 550,
	"./coffeemachine.jpg": 912,
	"./cookingessentials.jpg": 676,
	"./desk.jpg": 403,
	"./desklamp.jpg": 818,
	"./extensioncord.jpg": 983,
	"./fridge.jpg": 498,
	"./ironingboard.jpg": 713,
	"./laundrysupplies.jpg": 354,
	"./microwave.jpg": 437,
	"./nintendoswitch.jpg": 646,
	"./noimage.jpg": 377,
	"./paninipress.jpg": 786,
	"./storagebins.jpg": 627,
	"./television.jpg": 849,
	"./textbook.jpg": 407,
	"./toaster.jpg": 597,
	"./toolkit.jpg": 764,
	"./wafflemaker.jpg": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;